// per DESIGN.md §4B (page frame) and docs/ui-shape.md §5 — the one page header
// every list/admin screen shares: title, optional lede and meta line, and an
// actions slot that wraps instead of shrink-clipping its buttons.
import type { ReactNode } from 'react';

export interface PageHeaderProps {
  /* A ReactNode, not a string, because the wireframe writes state into the H1
     itself rather than beside it: `Sistem Registrator [Activ]`
     (wireframes/react/src/pages/AdminCredentiale.tsx:68), `{denumire} [Activ]`
     (AdminCoduri.tsx:198). The tag belongs to the title, so it has to be able to
     go inside it. Plain strings keep working unchanged. */
  title: ReactNode;
  /* A ReactNode for the same reason `title` is: the wireframe hangs an info tip
     off the sentence under the heading (`AdminAgregari.tsx:1825-1830`,
     `<PageHead sub={<span>… <InfoTip/></span>}>`). With a string here the only
     way to keep that explanation on the page was to inline it into the sentence,
     which pushed the lede onto a second line and moved everything below it down
     20px. Plain strings keep working unchanged. */
  lede?: ReactNode;
  meta?: string | undefined;
  actions?: ReactNode;
}

export function PageHeader({ title, lede, meta, actions }: PageHeaderProps): JSX.Element {
  return (
    <header className="simsm-page-header">
      <div className="simsm-page-header__text">
        <h1 className="simsm-page-header__title">{title}</h1>
        {lede ? <p className="simsm-page-header__lede">{lede}</p> : null}
        {meta ? <p className="simsm-page-header__meta">{meta}</p> : null}
      </div>
      {actions ? <div className="simsm-page-header__actions">{actions}</div> : null}
    </header>
  );
}
